
import { defineComponent } from "vue";

export default defineComponent({
  name: "ai-dm-onboarding",
  props: {
    integrationsUrl: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    completing: {
      type: Boolean,
      default: false
    },
    resetting: {
      type: Boolean,
      default: false
    },
    completed: {
      type: Boolean,
      default: false
    }
  },
  emits: ["complete", "reset"],
  methods: {
    openIntegrations() {
      if (!this.integrationsUrl) {
        return;
      }
      window.open(this.integrationsUrl, "_blank", "noopener,noreferrer");
    }
  }
});
